import apiCall from '../../api';

const service = {
    find() {
        return new Promise((resolve, reject) => {
            if (process.env.NODE_ENV !== 'production')
            apiCall.defaults.baseURL = "http://localhost:8081"
                apiCall.defaults.headers.common['Authorization'] = localStorage.getItem("token-type") + " " + localStorage.getItem("user-token");
                apiCall.get('/gsdialogo/api/v1/oficina?id=1' ).then(res => resolve(res.data)).catch(err => reject(err));
        });
    },
   
    update(model) {
        return new Promise((resolve, reject) => {
            if (process.env.NODE_ENV !== 'production')
            apiCall.defaults.baseURL = "http://localhost:8081"
                apiCall.defaults.headers.common['Authorization'] = localStorage.getItem("token-type") + " " + localStorage.getItem("user-token");
                apiCall.put('/gsdialogo/api/v1/oficina', model).then(res => resolve(res.data)).catch(err => reject(err));
        });
    },
}
export default service;